(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everide-advice-behavior-v3"]) return;
  try {
    
  (function () {
    function initAdviceV3(scope) {
      var root = (scope || document).querySelector('[data-everide-community]') || document.querySelector('[data-everide-community]');
      if (!root || root.dataset.adviceV3Ready === 'true') return;

      var search = root.querySelector('[data-community-search]');
      var controlBand = root.querySelector('.ecv2__control-band');
      var toolbar = root.querySelector('.ecv2__toolbar');
      var originalSearch = root.querySelector('.ecv2__search');
      var resultCount = root.querySelector('[data-result-count]');
      var workspace = root.querySelector('.ecv2__workspace');
      var workspaceContent = root.querySelector('.ecv2__content');
      var originalModes = Array.prototype.slice.call(root.querySelectorAll('[data-community-mode]'));
      var originalStages = Array.prototype.slice.call(root.querySelectorAll('[data-stage-filter]'));
      var askDialog = root.querySelector('[data-ask-dialog]');
      var empty = root.querySelector('[data-community-empty]');
      if (!search || !workspace || !originalSearch || !originalStages.length) return;

      root.dataset.adviceV3Ready = 'true';

      var finder = document.createElement('section');
      finder.className = 'eav3';
      finder.setAttribute('aria-label', 'EVERIDE Advice');
      finder.innerHTML =
        '<div class="eav3__shell">' +
          '<div class="eav3__topline">' +
            '<p class="eav3__eyebrow">EVERIDE ADVICE</p>' +
            '<div class="eav3__view" role="group" aria-label="Advice view">' +
              '<button type="button" data-eav3-mode="decision" class="is-active" aria-pressed="true">Get an answer</button>' +
              '<button type="button" data-eav3-mode="official" aria-pressed="false">Browse the library</button>' +
            '</div>' +
          '</div>' +
          '<div class="eav3__intro">' +
            '<h1>What do you need to know before you buy?</h1>' +
            '<p>Search sizing, fit, ride conditions, product use, delivery and rider questions. Most answers open right here.</p>' +
          '</div>' +
          '<div class="eav3__search-slot">' +
            '<div class="eav3__search-wrap" data-eav3-search-wrap><span class="eav3__search-label">Search answers</span></div>' +
            '<div class="eav3__examples"><span>Try:</span>' +
              '<button type="button" data-eav3-query="What size should I choose if I am between sizes?">Between sizes?</button>' +
              '<button type="button" data-eav3-query="What should I wear around 10°C?">What to wear at 10°C?</button>' +
              '<button type="button" data-eav3-query="Will I have to pay duties?">Duties?</button>' +
            '</div>' +
          '</div>' +
          '<div class="eav3__quick-wrap" data-eav3-quick-wrap>' +
            '<p class="eav3__quick-label">What are you trying to figure out?</p>' +
            '<div class="eav3__quick" data-eav3-quick role="group" aria-label="Common buying decisions"></div>' +
          '</div>' +
        '</div>';

      root.insertBefore(finder, workspace);

      var searchWrap = finder.querySelector('[data-eav3-search-wrap]');
      searchWrap.insertBefore(originalSearch, searchWrap.firstChild);

      var quick = finder.querySelector('[data-eav3-quick]');
      var labels = {
        ride: ['What should I wear?', 'Match kit to conditions'],
        compare: ['Which option is right?', 'Compare without guesswork'],
        fit: ['What size should I choose?', 'Size and fit'],
        performance: ['How will it perform?', 'Real-world use'],
        confidence: ['Shipping, returns & duties', 'Know before checkout'],
        ownership: ['Care & after purchase', 'Use it well']
      };

      originalStages.forEach(function (sourceButton) {
        var key = sourceButton.dataset.stageFilter;
        if (key === 'all') return;
        var copy = document.createElement('button');
        var text = labels[key] || [sourceButton.textContent.trim(), ''];
        copy.type = 'button';
        copy.dataset.eav3Stage = key;
        copy.innerHTML = '<span>' + text[0] + '</span><small>' + text[1] + '</small>';
        copy.addEventListener('click', function () {
          sourceButton.click();
          setActiveStage(key);
          if (window.matchMedia('(max-width: 749px)').matches) {
            workspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
        quick.appendChild(copy);
      });

      function setActiveStage(key) {
        Array.prototype.slice.call(finder.querySelectorAll('[data-eav3-stage]')).forEach(function (button) {
          button.classList.toggle('is-active', button.dataset.eav3Stage === key);
        });
      }

      function setActiveMode(mode) {
        Array.prototype.slice.call(finder.querySelectorAll('[data-eav3-mode]')).forEach(function (button) {
          var active = button.dataset.eav3Mode === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        finder.querySelector('[data-eav3-quick-wrap]').hidden = mode === 'official';
      }

      finder.querySelectorAll('[data-eav3-mode]').forEach(function (button) {
        button.addEventListener('click', function () {
          var mode = button.dataset.eav3Mode;
          var target = originalModes.find(function (item) {
            return item.dataset.communityMode === mode;
          });
          if (target) target.click();
          setActiveMode(mode);
        });
      });

      finder.querySelectorAll('[data-eav3-query]').forEach(function (button) {
        button.addEventListener('click', function () {
          search.value = button.dataset.eav3Query || '';
          search.dispatchEvent(new Event('input', { bubbles: true }));
          search.focus();
        });
      });

      var resultLine = document.createElement('div');
      resultLine.className = 'eav3__resultline';
      resultLine.innerHTML = '<span data-eav3-count-slot></span><button class="eav3__ask" type="button" data-eav3-ask>Still unsure? Ask EVERIDE</button>';
      if (workspaceContent) {
        workspaceContent.insertBefore(resultLine, workspaceContent.firstChild);
        if (resultCount) resultLine.querySelector('[data-eav3-count-slot]').appendChild(resultCount);
      }

      function syncQuestion() {
        if (!askDialog) return;
        var body = askDialog.querySelector('textarea[name="contact[body]"]');
        var decision = askDialog.querySelector('select[name="contact[purchase_decision]"]');
        var activeStage = originalStages.find(function (button) {
          return button.classList.contains('is-active') && button.dataset.stageFilter !== 'all';
        });
        if (body && search.value.trim() && !body.value.trim()) body.value = search.value.trim();
        if (decision && activeStage) decision.value = activeStage.dataset.stageFilter;
      }

      resultLine.querySelector('[data-eav3-ask]').addEventListener('click', function () {
        syncQuestion();
        var trigger = root.querySelector('[data-open-ask]');
        if (trigger) trigger.click();
      });

      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-open-ask]')) syncQuestion();
      }, true);

      function upgradeEmpty() {
        if (!empty || empty.dataset.eav3Ready === 'true') return;
        empty.dataset.eav3Ready = 'true';
        empty.classList.add('eav3__empty-upgraded');
        var title = empty.querySelector('[data-empty-title]');
        var text = empty.querySelector('[data-empty-text]');
        if (title) title.textContent = "We don't have a strong answer yet.";
        if (text) text.textContent = 'Ask EVERIDE and keep this question with your request.';
        var query = document.createElement('div');
        query.className = 'eav3__empty-query';
        query.hidden = true;
        var ask = document.createElement('button');
        ask.type = 'button';
        ask.className = 'eav3__empty-ask';
        ask.textContent = 'Ask EVERIDE about this';
        ask.addEventListener('click', function () {
          syncQuestion();
          var trigger = root.querySelector('[data-open-ask]');
          if (trigger) trigger.click();
        });
        if (text) text.insertAdjacentElement('afterend', query);
        empty.appendChild(ask);

        function updateQuery() {
          var value = search.value.trim();
          query.hidden = !value;
          query.textContent = value ? '“' + value + '”' : '';
        }
        search.addEventListener('input', updateQuery);
        updateQuery();
      }

      upgradeEmpty();

      var observer = new MutationObserver(function () {
        setActiveMode(root.dataset.mode || 'decision');
        var active = originalStages.find(function (button) {
          return button.classList.contains('is-active');
        });
        setActiveStage(active ? active.dataset.stageFilter : '');
        if (empty) {
          var title = empty.querySelector('[data-empty-title]');
          var text = empty.querySelector('[data-empty-text]');
          if (!empty.hidden) {
            if (title) title.textContent = "We don't have a strong answer yet.";
            if (text) text.textContent = 'Ask EVERIDE and keep this question with your request.';
          }
        }
      });
      observer.observe(root, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden', 'data-mode'] });

      if (controlBand) controlBand.setAttribute('aria-hidden', 'true');
      if (toolbar) toolbar.removeAttribute('style');
      setActiveMode(root.dataset.mode || 'decision');

      var initialStage = originalStages.find(function (button) {
        return button.classList.contains('is-active');
      });
      setActiveStage(initialStage ? initialStage.dataset.stageFilter : '');
    }

    function start(scope) {
      window.setTimeout(function () { initAdviceV3(scope); }, 30);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { start(document); });
    } else {
      start(document);
    }

    document.addEventListener('shopify:section:load', function (event) { start(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["everide-advice-resolver"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initEverideAdvice(scope) {
      var root = (scope || document).querySelector('[data-everide-advice]') || document.querySelector('[data-everide-advice]');
      if (!root || root.dataset.adviceReady === 'true') return;
      root.dataset.adviceReady = 'true';

      var search = root.querySelector('[data-community-search]');
      var stageButtons = Array.prototype.slice.call(root.querySelectorAll('[data-stage-filter]'));
      var kindButtons = Array.prototype.slice.call(root.querySelectorAll('[data-kind-filter]'));
      var modeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-community-mode]'));
      var libraryControls = root.querySelector('[data-library-controls]');
      var workspaceTitle = root.querySelector('[data-workspace-title]');
      var workspaceIntro = root.querySelector('[data-workspace-intro]');
      var askDialog = root.querySelector('[data-ask-dialog]');
      var askQuestion = root.querySelector('[data-ask-question]');
      var guideDialog = root.querySelector('[data-guide-dialog]');
      var guideDialogTitle = root.querySelector('[data-guide-dialog-title]');
      var guideDialogBody = root.querySelector('[data-guide-dialog-body]');
      var empty = root.querySelector('[data-community-empty]');
      var emptyTitle = root.querySelector('[data-empty-title]');
      var emptyText = root.querySelector('[data-empty-text]');
      var lastTrigger = null;

      function setPressed(buttons, dataKey, value) {
        buttons.forEach(function (button) {
          var active = button.dataset[dataKey] === value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      function showDialog(dialog) {
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }

      function closeDialog(dialog) {
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      }

      function fillQuestion() {
        if (!askQuestion || !search) return;
        var value = search.value.trim();
        if (value && !askQuestion.value.trim()) askQuestion.value = value;
      }

      function setMode(mode, scrollToWorkspace) {
        root.dataset.mode = mode;
        setPressed(modeButtons, 'communityMode', mode);
        if (libraryControls) libraryControls.hidden = mode !== 'official';
        if (workspaceTitle) workspaceTitle.textContent = mode === 'official' ? 'Browse the advice library' : 'Answers for your purchase decision';
        if (workspaceIntro) workspaceIntro.textContent = mode === 'official'
          ? 'Browse Q&A, FAQ, guides and official service information by source. Search still works across the same knowledge pool.'
          : 'Start with a question or choose a decision above. Short answers stay on this page; deeper guides remain optional.';
        if (scrollToWorkspace) {
          var workspace = root.querySelector('.eadv__workspace');
          if (workspace) workspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      stageButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setPressed(stageButtons, 'stageFilter', button.dataset.stageFilter);
          if (search) search.value = '';
          setMode('decision', false);
          if (workspaceTitle) workspaceTitle.textContent = button.dataset.stageTitle || 'Answers for your purchase decision';
          var workspace = root.querySelector('.eadv__workspace');
          if (workspace) workspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      kindButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setPressed(kindButtons, 'kindFilter', button.dataset.kindFilter);
        });
      });

      modeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setMode(button.dataset.communityMode, true);
        });
      });

      root.addEventListener('click', function (event) {
        var ask = event.target.closest('[data-open-ask]');
        var close = event.target.closest('[data-close-dialog]');
        var guide = event.target.closest('[data-open-guide]');
        var clear = event.target.closest('[data-clear-filters]');

        if (ask && root.contains(ask)) {
          lastTrigger = ask;
          fillQuestion();
          showDialog(askDialog);
        }

        if (guide && root.contains(guide)) {
          var template = root.querySelector('#' + guide.dataset.guideTemplate);
          if (template && guideDialogBody) {
            lastTrigger = guide;
            guideDialogTitle.textContent = guide.dataset.guideTitle || 'Guide';
            guideDialogBody.replaceChildren(template.content.cloneNode(true));
            showDialog(guideDialog);
          }
        }

        if (clear && root.contains(clear)) {
          if (search) search.value = '';
          setPressed(stageButtons, 'stageFilter', 'all');
          setPressed(kindButtons, 'kindFilter', 'all');
          setMode('decision', false);
          if (search) {
            search.dispatchEvent(new Event('input', { bubbles: true }));
            search.focus();
          }
        }

        if (close && root.contains(close)) closeDialog(close.closest('dialog'));
      });

      [askDialog, guideDialog].forEach(function (dialog) {
        if (!dialog) return;
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeDialog(dialog);
        });
        dialog.addEventListener('close', function () {
          if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
        });
      });

      if (search) {
        search.addEventListener('input', function () {
          if (root.dataset.mode !== 'decision') setMode('decision', false);
          if (search.value.trim().length >= 2 && workspaceTitle) workspaceTitle.textContent = 'Best answers for your question';
          if (!search.value.trim() && workspaceTitle) workspaceTitle.textContent = 'Answers for your purchase decision';
        });
        search.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            var workspace = root.querySelector('.eadv__workspace');
            if (workspace) workspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      if (empty && emptyTitle && emptyText) {
        var rewriteEmpty = function () {
          if (!empty.hidden) {
            emptyTitle.textContent = "We don't have a strong answer yet.";
            emptyText.textContent = "Ask EVERIDE and we'll reply directly. With your permission, an anonymised answer may also be added here for the next rider.";
          }
        };
        new MutationObserver(rewriteEmpty).observe(empty, { attributes: true, attributeFilter: ['hidden'] });
        rewriteEmpty();
      }

      if (root.querySelector('[data-form-status]')) showDialog(askDialog);
    }

    function start(scope) {
      window.setTimeout(function () { initEverideAdvice(scope); }, 0);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
    else start(document);

    document.addEventListener('shopify:section:load', function (event) { start(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["everide-community-hub-v1"] && !Shopify.designMode) return;
  try {
    
  function initEverideCommunity(scope) {
    var roots = (scope || document).querySelectorAll('[data-everide-community]');
    roots.forEach(function (root) {
      if (root.dataset.communityReady === 'true') return;
      root.dataset.communityReady = 'true';
      var search = root.querySelector('[data-community-search]');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-community-filter]'));
      var questions = Array.prototype.slice.call(root.querySelectorAll('[data-community-question]'));
      var noResults = root.querySelector('[data-community-no-results]');
      var activeStage = 'all';

      function applyFilters() {
        var term = search ? search.value.trim().toLowerCase() : '';
        var visibleCount = 0;
        questions.forEach(function (question) {
          var stageMatches = activeStage === 'all' || question.dataset.questionStage === activeStage;
          var textMatches = !term || (question.dataset.questionText || '').indexOf(term) !== -1;
          question.hidden = !(stageMatches && textMatches);
          if (!question.hidden) visibleCount += 1;
        });
        if (noResults) noResults.hidden = visibleCount !== 0;
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          activeStage = button.dataset.communityFilter || 'all';
          buttons.forEach(function (item) {
            var isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          applyFilters();
        });
      });

      if (search) search.addEventListener('input', applyFilters);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initEverideCommunity(document); });
  } else {
    initEverideCommunity(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initEverideCommunity(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["everide-community-hub-v2"] && !Shopify.designMode) return;
  try {
    
  function initEverideCommunityV2(scope) {
    var roots = (scope || document).querySelectorAll('[data-everide-community]');
    roots.forEach(function (root) {
      if (root.dataset.communityReady === 'true') return;
      root.dataset.communityReady = 'true';

      var search = root.querySelector('[data-community-search]');
      var results = root.querySelector('[data-community-results]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-community-item]'));
      var modeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-community-mode]'));
      var stageButtons = Array.prototype.slice.call(root.querySelectorAll('[data-stage-filter]'));
      var kindButtons = Array.prototype.slice.call(root.querySelectorAll('[data-kind-filter]'));
      var decisionPanel = root.querySelector('[data-decision-panel]');
      var decisionContext = root.querySelector('[data-decision-context]');
      var contextTitle = root.querySelector('[data-context-title]');
      var contextText = root.querySelector('[data-context-text]');
      var officialControls = root.querySelector('[data-official-controls]');
      var resultCount = root.querySelector('[data-result-count]');
      var empty = root.querySelector('[data-community-empty]');
      var emptyTitle = root.querySelector('[data-empty-title]');
      var emptyText = root.querySelector('[data-empty-text]');
      var clearButton = root.querySelector('[data-clear-filters]');
      var contentDialog = root.querySelector('[data-content-dialog]');
      var dialogTitle = root.querySelector('[data-dialog-title]');
      var dialogBody = root.querySelector('[data-dialog-body]');
      var askDialog = root.querySelector('[data-ask-dialog]');
      var state = { mode: 'decision', stage: 'all', kind: 'all' };
      var sourceCache = {};
      var lastTrigger = null;
      var params = new URLSearchParams(window.location.search);

      if (params.get('community_view') === 'official') state.mode = 'official';
      if (params.get('community_stage')) state.stage = params.get('community_stage');
      if (params.get('community_type')) state.kind = params.get('community_type');

      function changeView(change) {
        if (document.startViewTransition) {
          document.startViewTransition(change);
        } else {
          change();
        }
      }

      function updatePressed(buttons, key, value) {
        buttons.forEach(function (button) {
          var active = button.dataset[key] === value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      function updateUrl() {
        var url = new URL(window.location.href);
        url.searchParams.set('community_view', state.mode);
        if (state.mode === 'decision' && state.stage !== 'all') {
          url.searchParams.set('community_stage', state.stage);
        } else {
          url.searchParams.delete('community_stage');
        }
        if (state.mode === 'official' && state.kind !== 'all') {
          url.searchParams.set('community_type', state.kind);
        } else {
          url.searchParams.delete('community_type');
        }
        window.history.replaceState({}, '', url);
      }

      function setDecisionContext(button) {
        if (!button || !contextTitle || !contextText) return;
        contextTitle.textContent = button.dataset.contextTitle || '';
        contextText.textContent = button.dataset.contextText || '';
      }

      function applyFilters() {
        var term = search ? search.value.trim().toLowerCase() : '';
        var visibleItems = 0;
        var visibleContent = 0;

        items.forEach(function (item) {
          var stages = (item.dataset.stages || '').split(/\s+/);
          var stageMatch = state.stage === 'all' || stages.indexOf(state.stage) !== -1;
          var kindMatch = state.kind === 'all' || item.dataset.kind === state.kind;
          var textMatch = !term || (item.dataset.search || '').indexOf(term) !== -1;
          var modeMatch = state.mode === 'decision' ? stageMatch : kindMatch;
          item.hidden = !(modeMatch && textMatch);
          if (!item.hidden) {
            visibleItems += 1;
            if (!item.hasAttribute('data-placeholder')) visibleContent += 1;
          }
        });

        if (resultCount) {
          resultCount.textContent = visibleContent + ' ' + (visibleContent === 1 ? root.dataset.resultsOne : root.dataset.resultsMany);
        }

        if (results) results.setAttribute('aria-label', visibleContent + ' ' + root.dataset.resultsMany);

        if (empty) {
          empty.hidden = visibleItems !== 0;
          if (!empty.hidden) {
            emptyTitle.textContent = root.dataset.emptyTitle;
            if (state.mode === 'official' && state.kind === 'review') {
              emptyText.textContent = root.dataset.reviewsEmpty;
            } else if (state.mode === 'official' && state.kind === 'update') {
              emptyText.textContent = root.dataset.updatesEmpty;
            } else {
              emptyText.textContent = root.dataset.emptyText;
            }
          }
        }
      }

      function setMode(mode, writeUrl) {
        state.mode = mode;
        changeView(function () {
          root.dataset.mode = mode;
          decisionPanel.hidden = mode !== 'decision';
          decisionContext.hidden = mode !== 'decision';
          officialControls.hidden = mode !== 'official';
          updatePressed(modeButtons, 'communityMode', mode);
          applyFilters();
        });
        if (mode === 'official') warmSources();
        if (writeUrl) updateUrl();
      }

      function showDialog(dialog) {
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }

      function closeDialog(dialog) {
        if (!dialog) return;
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }

      function cleanSource(html, url) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var source = parsed.querySelector('#MainContent > .shopify-section') || parsed.querySelector('#MainContent') || parsed.querySelector('main');
        if (!source) throw new Error('Missing source content');
        var clone = source.cloneNode(true);
        Array.prototype.slice.call(clone.querySelectorAll('script, style, link, iframe, noscript')).forEach(function (node) {
          node.remove();
        });
        Array.prototype.slice.call(clone.querySelectorAll('a[href]')).forEach(function (link) {
          var href = link.getAttribute('href');
          if (!href || href.charAt(0) === '#') return;
          try {
            link.setAttribute('href', new URL(href, url).href);
          } catch (error) {
            link.removeAttribute('href');
          }
        });
        return {
          html: '<div class="ecv2__source">' + clone.innerHTML + '</div>',
          text: (clone.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase()
        };
      }

      function getSource(url) {
        if (!sourceCache[url]) {
          sourceCache[url] = window.fetch(url, { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) throw new Error('Source request failed');
              return response.text();
            })
            .then(function (html) {
              return cleanSource(html, url);
            });
        }
        return sourceCache[url];
      }

      function indexSource(item) {
        var url = item.dataset.sourceUrl;
        if (!url || item.dataset.sourceIndexed === 'true') return Promise.resolve();
        item.dataset.sourceIndexed = 'loading';
        return getSource(url)
          .then(function (source) {
            item.dataset.search = (item.dataset.search + ' ' + source.text).trim();
            item.dataset.sourceIndexed = 'true';
            var label = item.querySelector('[data-source-state]');
            if (label) label.textContent = root.dataset.sourceReady;
            applyFilters();
          })
          .catch(function () {
            item.dataset.sourceIndexed = 'error';
          });
      }

      function warmSources() {
        items.forEach(function (item) {
          if (item.dataset.sourceUrl) indexSource(item);
        });
      }

      function openLocal(button) {
        var template = root.querySelector('#' + button.dataset.templateId);
        if (!template || !contentDialog || !dialogBody) return;
        lastTrigger = button;
        dialogTitle.textContent = button.dataset.contentTitle || '';
        dialogBody.removeAttribute('aria-busy');
        dialogBody.replaceChildren(template.content.cloneNode(true));
        showDialog(contentDialog);
      }

      function openRemote(button) {
        var url = button.dataset.sourceUrl;
        if (!url || !contentDialog || !dialogBody) return;
        lastTrigger = button;
        dialogTitle.textContent = button.dataset.contentTitle || '';
        dialogBody.setAttribute('aria-busy', 'true');
        dialogBody.innerHTML = '<div class="ecv2__loading">' + root.dataset.loading + '</div>';
        showDialog(contentDialog);
        getSource(url)
          .then(function (source) {
            dialogBody.removeAttribute('aria-busy');
            dialogBody.innerHTML = source.html;
            var item = button.closest('[data-community-item]');
            if (item) indexSource(item);
          })
          .catch(function () {
            dialogBody.removeAttribute('aria-busy');
            dialogBody.innerHTML = '<div class="ecv2__empty"><p>' + root.dataset.loadError + '</p><a href="' + url + '">' + button.dataset.contentTitle + '</a></div>';
          });
      }

      modeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setMode(button.dataset.communityMode, true);
        });
      });

      stageButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          state.stage = button.dataset.stageFilter;
          updatePressed(stageButtons, 'stageFilter', state.stage);
          setDecisionContext(button);
          applyFilters();
          updateUrl();
        });
      });

      kindButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          state.kind = button.dataset.kindFilter;
          updatePressed(kindButtons, 'kindFilter', state.kind);
          applyFilters();
          updateUrl();
        });
      });

      root.addEventListener('click', function (event) {
        var contentButton = event.target.closest('[data-open-content]');
        var askButton = event.target.closest('[data-open-ask]');
        var closeButton = event.target.closest('[data-close-dialog]');
        if (contentButton && root.contains(contentButton)) {
          if (contentButton.dataset.sourceUrl) openRemote(contentButton);
          else openLocal(contentButton);
        }
        if (askButton && root.contains(askButton)) {
          lastTrigger = askButton;
          showDialog(askDialog);
        }
        if (closeButton && root.contains(closeButton)) closeDialog(closeButton.closest('dialog'));
      });

      if (dialogBody) {
        dialogBody.addEventListener('click', function (event) {
          var link = event.target.closest('a[href]');
          if (!link) return;
          var targetUrl;
          try {
            targetUrl = new URL(link.href, window.location.origin);
          } catch (error) {
            return;
          }
          if (targetUrl.pathname === '/pages/contact') {
            event.preventDefault();
            closeDialog(contentDialog);
            showDialog(askDialog);
            return;
          }
          var matchingItem = items.find(function (item) {
            if (!item.dataset.sourceUrl) return false;
            return new URL(item.dataset.sourceUrl, window.location.origin).pathname === targetUrl.pathname;
          });
          if (matchingItem) {
            event.preventDefault();
            var matchingButton = matchingItem.querySelector('[data-open-content]');
            if (matchingButton) openRemote(matchingButton);
          }
        });
      }

      [contentDialog, askDialog].forEach(function (dialog) {
        if (!dialog) return;
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeDialog(dialog);
        });
        dialog.addEventListener('close', function () {
          if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
        });
      });

      if (search) {
        search.addEventListener('input', function () {
          applyFilters();
          if (search.value.trim().length >= 2) warmSources();
        });
      }

      if (clearButton) {
        clearButton.addEventListener('click', function () {
          if (search) search.value = '';
          state.stage = 'all';
          state.kind = 'all';
          updatePressed(stageButtons, 'stageFilter', 'all');
          updatePressed(kindButtons, 'kindFilter', 'all');
          setDecisionContext(stageButtons[0]);
          applyFilters();
          updateUrl();
          if (search) search.focus();
        });
      }

      updatePressed(stageButtons, 'stageFilter', state.stage);
      updatePressed(kindButtons, 'kindFilter', state.kind);
      var activeStage = stageButtons.find(function (button) {
        return button.dataset.stageFilter === state.stage;
      }) || stageButtons[0];
      setDecisionContext(activeStage);
      setMode(state.mode, false);
      if (root.querySelector('[data-form-status]')) showDialog(askDialog);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initEverideCommunityV2(document);
    });
  } else {
    initEverideCommunityV2(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initEverideCommunityV2(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["everide-community-knowledge-engine"]) return;
  try {
    
  (function () {
    function initEverideCommunityEngine(scope) {
      var context = scope || document;
      var root = context.querySelector('[data-everide-community]') || document.querySelector('[data-everide-community]');
      if (!root || root.dataset.knowledgeEngineReady === 'true') return;

      root.dataset.knowledgeEngineReady = 'true';

      var grid = root.querySelector('[data-community-results]');
      var search = root.querySelector('[data-community-search]');
      var resultCount = root.querySelector('[data-result-count]');
      var empty = root.querySelector('[data-community-empty]');
      var emptyTitle = root.querySelector('[data-empty-title]');
      var emptyText = root.querySelector('[data-empty-text]');
      var sourceCards = Array.prototype.slice.call(root.querySelectorAll('.ecv2__card--source[data-source-url]'));
      var originalSourceCount = sourceCards.length;
      var sourceReadyCount = 0;
      var sourceFailedCount = 0;
      var answerSequence = 0;
      var loadingNote;
      var spotlight;
      var spotlightTitle;
      var spotlightKind;
      var spotlightAnswer;
      var scheduled = false;

      if (!grid) return;

      function normalise(value) {
        return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
      }

      function textOf(node) {
        return normalise(node ? node.textContent : '');
      }

      function previewText(value, limit) {
        var text = (value || '').replace(/\s+/g, ' ').trim();
        if (text.length <= limit) return text;
        return text.slice(0, limit - 1).trim() + '…';
      }

      function previewAwareUrl(url) {
        var target = new URL(url, window.location.origin);
        var current = new URL(window.location.href);
        ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
          if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
        });
        return target.href;
      }

      function cleanClone(node, baseUrl) {
        var clone = node.cloneNode(true);
        Array.prototype.slice.call(clone.querySelectorAll('script, style, link, iframe, form, input, textarea, select, button, noscript')).forEach(function (item) {
          item.remove();
        });
        Array.prototype.slice.call(clone.querySelectorAll('[id]')).forEach(function (item) {
          item.removeAttribute('id');
        });
        Array.prototype.slice.call(clone.querySelectorAll('a[href]')).forEach(function (link) {
          var href = link.getAttribute('href');
          if (!href || href.charAt(0) === '#') return;
          try {
            link.setAttribute('href', new URL(href, baseUrl).href);
          } catch (error) {
            link.removeAttribute('href');
          }
        });
        return clone;
      }

      function kindLabel(kind) {
        if (kind === 'question') return 'Rider Q&A';
        if (kind === 'faq') return 'FAQ';
        if (kind === 'guide') return 'Guides & field notes';
        if (kind === 'review') return 'Reviews';
        if (kind === 'update') return 'Updates';
        return 'Policies & services';
      }

      function faqStages(category) {
        var value = normalise(category);
        if (value.indexOf('sizing') !== -1 || value.indexOf('fit') !== -1) return 'fit';
        if (value.indexOf('return') !== -1 || value.indexOf('exchange') !== -1) return 'fit confidence';
        if (value.indexOf('ride assurance') !== -1) return 'confidence ownership';
        if (value.indexOf('contact') !== -1 || value.indexOf('support') !== -1) return 'confidence ownership';
        return 'confidence';
      }

      function makeDirectUnit(unit) {
        var card = document.createElement('article');
        var details = document.createElement('details');
        var summary = document.createElement('summary');
        var topline = document.createElement('span');
        var type = document.createElement('span');
        var context = document.createElement('span');
        var title = document.createElement('span');
        var preview = document.createElement('span');
        var toggle = document.createElement('span');
        var body = document.createElement('div');

        answerSequence += 1;
        card.id = 'ecv3-answer-' + answerSequence;
        card.className = 'ecv2__card ecv3__direct-unit';
        card.setAttribute('data-community-item', '');
        card.dataset.kind = unit.kind || 'official';
        card.dataset.stages = unit.stages || 'confidence';
        card.dataset.directAnswer = 'true';
        card.dataset.answerTitle = unit.title || '';
        card.dataset.answerText = normalise(unit.text || '');
        card.dataset.search = normalise([
          unit.title,
          unit.text,
          unit.context,
          unit.keywords,
          kindLabel(unit.kind)
        ].join(' '));
        card._ecv3AnswerHtml = unit.html || '';
        card._ecv3AnswerSource = unit.sourceUrl || '';

        details.className = 'ecv3__answer';
        summary.className = 'ecv3__answer-summary';

        topline.className = 'ecv2__card-topline';
        type.textContent = kindLabel(unit.kind);
        context.textContent = unit.context || 'Direct answer';
        topline.appendChild(type);
        topline.appendChild(context);

        title.className = 'ecv3__answer-title';
        title.textContent = unit.title || 'Answer';

        preview.className = 'ecv3__answer-preview';
        preview.textContent = previewText(unit.text || '', 180);

        toggle.className = 'ecv3__answer-toggle';
        toggle.textContent = 'Show answer here';

        body.className = 'ecv3__answer-body';
        body.innerHTML = unit.html || '';

        if (unit.sourceUrl) {
          var source = document.createElement('a');
          source.className = 'ecv3__answer-source';
          source.href = unit.sourceUrl;
          source.textContent = 'Open full source';
          body.appendChild(source);
        }

        summary.appendChild(topline);
        summary.appendChild(title);
        summary.appendChild(preview);
        summary.appendChild(toggle);
        details.appendChild(summary);
        details.appendChild(body);
        card.appendChild(details);

        details.addEventListener('toggle', function () {
          toggle.firstChild.nodeValue = details.open ? 'Hide answer ' : 'Show answer here ';
        });

        return card;
      }

      function upgradeRenderedQuestions() {
        var questionCards = Array.prototype.slice.call(root.querySelectorAll('[data-community-item][data-kind="question"]:not([data-placeholder])'));
        questionCards.forEach(function (card) {
          if (card.dataset.directAnswer === 'true') return;
          var button = card.querySelector('[data-template-id]');
          if (!button) return;
          var template = root.querySelector('#' + button.dataset.templateId);
          if (!template) return;
          var copy = template.content.querySelector('.ecv2__detail-copy');
          if (!copy) return;

          var clonedCopy = copy.cloneNode(true);
          var actions = template.content.querySelector('.ecv2__detail-actions');
          if (actions) clonedCopy.appendChild(actions.cloneNode(true));

          var unit = {
            kind: 'question',
            stages: card.dataset.stages || 'ride compare fit performance confidence ownership',
            title: button.dataset.contentTitle || '',
            text: textOf(copy),
            html: clonedCopy.innerHTML,
            context: 'EVERIDE official answer'
          };
          var direct = makeDirectUnit(unit);
          card.id = direct.id;
          card.className = direct.className;
          card.dataset.directAnswer = 'true';
          card.dataset.answerTitle = direct.dataset.answerTitle;
          card.dataset.answerText = direct.dataset.answerText;
          card.dataset.search = normalise((card.dataset.search || '') + ' ' + direct.dataset.search);
          card._ecv3AnswerHtml = direct._ecv3AnswerHtml;
          card._ecv3AnswerSource = '';
          card.replaceChildren(direct.firstChild);
        });
      }

      function faqUnits(parsed, url) {
        var units = [];
        var groups = Array.prototype.slice.call(parsed.querySelectorAll('.everide-faq__group'));

        groups.forEach(function (group) {
          var heading = group.querySelector('.everide-faq__group-title, h2, h3');
          var category = heading ? heading.textContent.trim() : 'FAQ';
          var items = Array.prototype.slice.call(group.querySelectorAll('.everide-faq__item, details'));

          items.forEach(function (item) {
            var summary = item.querySelector('.everide-faq__summary, summary');
            var answer = item.querySelector('.everide-faq__answer') || (summary ? summary.nextElementSibling : null);
            if (!summary || !answer) return;

            var questionNode = summary.querySelector('span') || summary;
            var question = questionNode.textContent.replace(/\s+/g, ' ').trim();
            var answerClone = cleanClone(answer, url);
            var answerText = textOf(answerClone);
            if (!question || !answerText) return;

            units.push({
              kind: 'faq',
              stages: faqStages(category),
              title: question,
              text: answerText,
              html: answerClone.innerHTML,
              context: category,
              keywords: category,
              sourceUrl: new URL(url, window.location.origin).pathname
            });
          });
        });

        return units;
      }

      function genericUnits(parsed, sourceCard, url) {
        var main = parsed.querySelector('#MainContent') || parsed.querySelector('main');
        if (!main) return [];

        var stages = sourceCard.dataset.stages || 'confidence';
        var sourceTitleNode = sourceCard.querySelector('.ecv2__card-title');
        var sourceTitle = sourceTitleNode ? sourceTitleNode.textContent.trim() : 'Official guidance';
        var candidates = Array.prototype.slice.call(main.querySelectorAll('section, article, details'));
        var selected = [];
        var seen = [];

        candidates.forEach(function (node) {
          var heading = node.matches('details') ? node.querySelector('summary') : node.querySelector('h2, h3');
          if (!heading) return;
          var text = textOf(node);
          if (text.length < 90 || text.length > 6500) return;

          var nested = Array.prototype.slice.call(node.querySelectorAll('section, article, details')).some(function (child) {
            if (child === node) return false;
            var childHeading = child.matches('details') ? child.querySelector('summary') : child.querySelector('h2, h3');
            return !!childHeading && textOf(child).length >= 90;
          });
          if (nested && !node.matches('details')) return;

          var title = heading.textContent.replace(/\s+/g, ' ').trim();
          if (!title) return;
          var key = normalise(title);
          if (seen.indexOf(key) !== -1) return;
          seen.push(key);
          selected.push({ node: node, heading: heading, title: title });
        });

        if (!selected.length) {
          Array.prototype.slice.call(main.querySelectorAll('h2, h3')).slice(0, 10).forEach(function (heading) {
            var parent = heading.parentElement;
            if (!parent) return;
            var text = textOf(parent);
            if (text.length < 90 || text.length > 6500) return;
            var title = heading.textContent.replace(/\s+/g, ' ').trim();
            var key = normalise(title);
            if (!title || seen.indexOf(key) !== -1) return;
            seen.push(key);
            selected.push({ node: parent, heading: heading, title: title });
          });
        }

        return selected.slice(0, 12).map(function (entry) {
          var clone = cleanClone(entry.node, url);
          var cloneHeading = clone.querySelector('h2, h3, summary');
          if (cloneHeading && normalise(cloneHeading.textContent) === normalise(entry.title)) cloneHeading.remove();
          var text = textOf(clone);
          return {
            kind: sourceCard.dataset.kind || 'official',
            stages: stages,
            title: entry.title,
            text: text,
            html: clone.innerHTML,
            context: sourceTitle,
            keywords: sourceTitle,
            sourceUrl: new URL(url, window.location.origin).pathname
          };
        }).filter(function (unit) {
          return unit.text.length >= 40;
        });
      }

      function fetchSourceCard(card) {
        var rawUrl = card.dataset.sourceUrl;
        if (!rawUrl) return Promise.resolve(false);
        var fetchUrl = previewAwareUrl(rawUrl);
        var state = card.querySelector('[data-source-state]');
        if (state) state.textContent = 'Building direct answers…';

        return window.fetch(fetchUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Source request failed');
            return response.text();
          })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var path = new URL(rawUrl, window.location.origin).pathname;
            var units = path === '/pages/faq' ? faqUnits(parsed, rawUrl) : genericUnits(parsed, card, rawUrl);
            if (!units.length) throw new Error('No atomic units found');

            var fragment = document.createDocumentFragment();
            units.forEach(function (unit) {
              fragment.appendChild(makeDirectUnit(unit));
            });
            card.replaceWith(fragment);
            sourceReadyCount += 1;
            return true;
          })
          .catch(function () {
            sourceFailedCount += 1;
            if (state) state.textContent = 'Open current source';
            return false;
          });
      }

      function createInterfaceAdditions() {
        spotlight = document.createElement('section');
        spotlight.className = 'ecv3__spotlight';
        spotlight.hidden = true;
        spotlight.innerHTML =
          '<div class="ecv3__spotlight-head">' +
            '<p class="ecv3__spotlight-label">BEST DIRECT MATCH</p>' +
            '<p class="ecv3__spotlight-kind" data-ecv3-spotlight-kind></p>' +
          '</div>' +
          '<h3 data-ecv3-spotlight-title></h3>' +
          '<div class="ecv3__spotlight-answer" data-ecv3-spotlight-answer></div>';

        spotlightKind = spotlight.querySelector('[data-ecv3-spotlight-kind]');
        spotlightTitle = spotlight.querySelector('[data-ecv3-spotlight-title]');
        spotlightAnswer = spotlight.querySelector('[data-ecv3-spotlight-answer]');
        grid.parentNode.insertBefore(spotlight, grid);

        loadingNote = document.createElement('p');
        loadingNote.className = 'ecv3__loading-note';
        loadingNote.textContent = 'Preparing FAQ and official guidance as direct answers…';
        grid.parentNode.insertBefore(loadingNote, spotlight);
      }

      function activeValue(selector, dataName) {
        var active = root.querySelector(selector + '.is-active');
        return active ? active.dataset[dataName] || 'all' : 'all';
      }

      function scoreItem(item, term) {
        if (!term) return 0;
        var titleNode = item.querySelector('.ecv2__card-title, .ecv3__answer-title');
        var title = normalise(item.dataset.answerTitle || (titleNode ? titleNode.textContent : '') || '');
        var haystack = normalise(item.dataset.search || item.textContent || '');
        var phrase = normalise(term);
        var tokens = phrase.split(/\s+/).filter(Boolean);
        var score = 0;

        if (title.indexOf(phrase) !== -1) score += 30;
        if (haystack.indexOf(phrase) !== -1) score += 12;
        tokens.forEach(function (token) {
          if (title.indexOf(token) !== -1) score += 8;
          if (haystack.indexOf(token) !== -1) score += 2;
        });
        return score;
      }

      function refreshOriginalOrder() {
        Array.prototype.slice.call(grid.querySelectorAll('[data-community-item]')).forEach(function (item, index) {
          if (!item.dataset.ecv3Order) item.dataset.ecv3Order = String(index + 1);
        });
      }

      function applyDynamicFilters() {
        scheduled = false;
        var mode = root.dataset.mode || 'decision';
        var stage = activeValue('[data-stage-filter]', 'stageFilter');
        var kind = activeValue('[data-kind-filter]', 'kindFilter');
        var term = search ? normalise(search.value) : '';
        var items = Array.prototype.slice.call(grid.querySelectorAll('[data-community-item]'));
        var visibleItems = [];
        var visibleContent = 0;

        items.forEach(function (item) {
          var stages = (item.dataset.stages || '').split(/\s+/);
          var stageMatch = stage === 'all' || stages.indexOf(stage) !== -1;
          var kindMatch = kind === 'all' || item.dataset.kind === kind;
          var haystack = normalise(item.dataset.search || item.textContent || '');
          var textMatch = !term || haystack.indexOf(term) !== -1 ||
            term.split(/\s+/).filter(Boolean).every(function (token) {
              return haystack.indexOf(token) !== -1;
            });
          var modeMatch = mode === 'decision' ? stageMatch : kindMatch;
          var visible = modeMatch && textMatch;

          item.hidden = !visible;
          if (visible) {
            visibleItems.push(item);
            if (!item.hasAttribute('data-placeholder')) visibleContent += 1;
          }
        });

        if (term) {
          visibleItems.sort(function (a, b) {
            return scoreItem(b, term) - scoreItem(a, term);
          }).forEach(function (item) {
            grid.appendChild(item);
          });
        } else {
          items.sort(function (a, b) {
            return Number(a.dataset.ecv3Order || 9999) - Number(b.dataset.ecv3Order || 9999);
          }).forEach(function (item) {
            grid.appendChild(item);
          });
        }

        if (resultCount) {
          resultCount.textContent = visibleContent + ' ' + (visibleContent === 1 ? 'useful item' : 'useful items');
        }

        if (empty) {
          var anyVisible = visibleItems.length > 0;
          empty.hidden = anyVisible;
          if (!anyVisible && emptyTitle && emptyText) {
            emptyTitle.textContent = 'Nothing matches this view yet.';
            if (mode === 'official' && kind === 'review') {
              emptyText.textContent = root.dataset.reviewsEmpty || 'No verified buyer reviews have been published in this hub yet.';
            } else if (mode === 'official' && kind === 'update') {
              emptyText.textContent = root.dataset.updatesEmpty || 'There are no current community updates to publish.';
            } else {
              emptyText.textContent = 'Try fewer words, another decision stage or another official content type.';
            }
          }
        }

        updateSpotlight(term, visibleItems);
      }

      function updateSpotlight(term, visibleItems) {
        if (!spotlight || term.length < 2) {
          if (spotlight) spotlight.hidden = true;
          return;
        }

        var direct = visibleItems.filter(function (item) {
          return item.dataset.directAnswer === 'true';
        });

        if (!direct.length) {
          spotlight.hidden = true;
          return;
        }

        direct.sort(function (a, b) {
          return scoreItem(b, term) - scoreItem(a, term);
        });

        var best = direct[0];
        spotlightTitle.textContent = best.dataset.answerTitle || 'Direct answer';
        spotlightKind.textContent = kindLabel(best.dataset.kind);
        spotlightAnswer.innerHTML = best._ecv3AnswerHtml || '<p>' + previewText(best.dataset.answerText || '', 500) + '</p>';

        if (best._ecv3AnswerSource) {
          var source = document.createElement('a');
          source.className = 'ecv3__answer-source';
          source.href = best._ecv3AnswerSource;
          source.textContent = 'Open full source';
          spotlightAnswer.appendChild(source);
        }

        spotlight.hidden = false;
      }

      function scheduleApply() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(applyDynamicFilters);
      }

      function finishSourceLoading() {
        if (!loadingNote) return;
        if (sourceReadyCount > 0) {
          loadingNote.textContent = sourceReadyCount + ' official source' + (sourceReadyCount === 1 ? '' : 's') + ' converted into direct answers on this page.';
          window.setTimeout(function () {
            loadingNote.hidden = true;
          }, 2400);
        } else if (originalSourceCount && sourceFailedCount === originalSourceCount) {
          loadingNote.textContent = 'Direct answer indexing is unavailable right now. The current source cards remain available.';
        } else {
          loadingNote.hidden = true;
        }
      }

      createInterfaceAdditions();
      upgradeRenderedQuestions();

      Promise.all(sourceCards.map(fetchSourceCard)).then(function () {
        refreshOriginalOrder();
        finishSourceLoading();
        scheduleApply();
      });

      refreshOriginalOrder();
      scheduleApply();

      root.addEventListener('click', function (event) {
        if (
          event.target.closest('[data-community-mode]') ||
          event.target.closest('[data-stage-filter]') ||
          event.target.closest('[data-kind-filter]') ||
          event.target.closest('[data-clear-filters]')
        ) {
          window.setTimeout(scheduleApply, 0);
        }
      }, true);

      if (search) {
        search.addEventListener('input', scheduleApply, true);
      }

      var observer = new MutationObserver(function (mutations) {
        var shouldApply = mutations.some(function (mutation) {
          return mutation.type === 'attributes' && mutation.attributeName === 'data-mode';
        });
        if (shouldApply) scheduleApply();
      });
      observer.observe(root, { attributes: true, attributeFilter: ['data-mode'] });
    }

    function start(scope) {
      window.setTimeout(function () {
        initEverideCommunityEngine(scope);
      }, 0);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        start(document);
      });
    } else {
      start(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      start(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
